import { useOverride } from '@override';
import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

import { USER_LAYOUT_PER_SECOND } from '@constants';
import { useSignOut } from '@hooks/user';
import { useSettings } from '@hooks/useSettings';
import { Header } from './Header';
import classes from './UserLayout.module.css';

export const UserLayout = () => {
  const Override = useOverride();
  const { data: settings } = useSettings();
  const navigate = useNavigate();
  const navigationCallback = () => {
    navigate('/auth');
  };
  const signOutMutation = useSignOut(navigationCallback);

  useEffect(() => {
    if (settings) {
      const timeout = setTimeout(() => {
        signOutMutation.mutate();
      }, USER_LAYOUT_PER_SECOND * settings.jwtExpirationTime);

      return () => clearTimeout(timeout);
    }
  }, [settings]);

  return (
    <div className={classes.layoutContainer}>
      <Header />
      <div className={classes.container}>
        <Override.Sidebar />
        <div className={classes.contentWrapper}>
          <div className={classes.content}>
            <div className={classes.contentBox}>
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
